import React, { useEffect, useState } from "react";
import * as XLSX from 'xlsx';
import SplitPane from "react-split-pane";
import Pagination from "../../../Pagination";
import Loader from "../../../../img/Document scan.gif"
import Swal from "sweetalert2";
import TableProperties from "./TableProperties";
import DatasetFilter from "./DatasetFilter";
import UseToggle from "../../../../Hooks/UseToggle";

import { ListGroup, Table } from "react-bootstrap";
import { saveAs } from 'file-saver';
import { useParams } from "react-router-dom";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { studyDatasetsServices } from "../../../../APIServices/studyDatasetsServices";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { FaArrowsRotate } from "react-icons/fa6";
import { studyOtherSettingsServices } from "../../../../APIServices/studyOtherSettingsServices";

const DatasetListByFieldNameLabel = ({ onMouseDown, tableRef }) => {
  const [formMetadataList, setFormMetadataList] = useState([]);
  const [formDataList, setFormDataList] = useState([]);
  const [formDataCount, setFormDataCount] = useState(0);
  const [formDataColumn, setFormDataColumn] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formId, setFormId] = useState("");
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [dataLoader, setDataLoader] = useState(false);
  const [csvLoader, setCsvLoader] = useState(false);
  const [excelLoader, setExcelLoader] = useState(false);
  const [dataStoreLoader, setDataStoreLoader] = useState(false);
  let { studyId } = useParams();
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();
  const studyPermission = JSON.parse(localStorage.getItem("studyPermissionData"));

  const [tableColumns, setTableColumns] = useState({});
  const [buttonLoader, setButtonLoader] = useState(false);
  const [buttonFiletrLoader, setButtonFilterLoader] = useState(false);

  const { toggle, setToggle, toggle1, setToggle1 } =
    UseToggle();

  const getStudyLevelForm = async (e) => {
    setLoading(true);
    let data = await studyLevelFormManagementServices.getStudyLevelForm(
      studyId,
      LoginCat,
      StudyMode
    );
    setFormMetadataList(data?.data || []);
    setLoading(false);
  };

  const storeAllDataEntryDatasetsByNameLabel = async () => {
    setDataStoreLoader(true);
    let userData = {}
    userData.studyId = studyId
    userData.formId = formId
    userData.mode = StudyMode
    let data = await studyDatasetsServices.storeAllDataEntryDatasetsByNameLabel(userData);
    if (data?.statusCode === 200) {
      getAllDataEntryDatasetsByNameLabel()
    }
    setDataStoreLoader(false);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(formDataCount / itemsPerPage);

  const getAllDataEntryDatasetsByNameLabel = async () => {
    setDataLoader(true);
    let userData = {}
    userData.studyId = studyId
    userData.formId = formId
    userData.mode = StudyMode
    userData.page = pageNumber;
    userData.length = itemsPerPage
    let data = await studyDatasetsServices.getAllDataEntryDatasetsByNameLabel(userData);
    setFormDataList(data?.row || []);
    setFormDataColumn(convertToTableData(data?.row || []));
    setFormDataCount(data?.count || 0);
    setDataLoader(false);
  };

  const getAllDataEntryCSVDownloadDatasets = async (extractDate) => {
    setCsvLoader(true);
    let userData = {}
    userData.studyId = studyId
    userData.formId = formId
    userData.mode = StudyMode
    if (extractDate) {
      userData.extractedDT = new Date()
    }
    let data = await studyDatasetsServices.getAllDataEntryDatasetsByNameLabel(userData);
    let formDataList = (data?.row || []);
    let formDataColumn = convertToTableData(data?.row || []);
    downloadCSV(formDataList, formDataColumn)
    setCsvLoader(false);
    if (extractDate) {
      getAllDataEntryDatasetsByNameLabel()
    }
  };

  const getAllDataEntryExcelDownloadDatasets = async (extractDate) => {
    setExcelLoader(true);
    let userData = {}
    userData.studyId = studyId
    userData.formId = formId
    userData.mode = StudyMode
    if (extractDate) {
      userData.extractedDT = new Date()
    }
    let data = await studyDatasetsServices.getAllDataEntryDatasetsByNameLabel(userData);
    let formDataList = (data?.row || []);
    let formDataColumn = convertToTableData(data?.row || []);
    downloadExcel(formDataList, formDataColumn)
    setExcelLoader(false);
    if (extractDate) {
      getAllDataEntryExcelDownloadDatasets()
    }
  };

  function convertToTableData(data) {
    const allColumns = [];
    data?.forEach(obj => {
      Object.keys(obj.fieldRow).forEach(key => {
        if (!allColumns.includes(key)) {
          allColumns.push(key);
        }
      });
    });
    return allColumns;
  }

  const downloadCSV = (formDataList, formDataColumn) => {
    const headers = ["Sr.", ...formDataColumn];
    const rows = formDataList.map((row, rowIndex) => {
      return [
        rowIndex + 1,
        ...formDataColumn.map((key) => row?.fieldRow?.[key] ?? ""),
      ];
    });

    const csvString = [headers, ...rows]
      .map((r) =>
        r.map((val) => `"${String(val ?? "").replace(/"/g, '""')}"`).join(",")
      )
      .join("\n");

    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", `${formDataList?.[0]?.fieldRow?.FORM || "export"}.csv`); // ✅ now always defined
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadExcel = (formDataList, formDataColumn) => {
    const headers = ["Sr.", ...formDataColumn];
    const rows = formDataList.map((row, rowIndex) => [
      rowIndex + 1,
      ...formDataColumn.map((key) => row?.fieldRow?.[key] ?? "")
    ]);
    const data = [headers, ...rows];
    const ws = XLSX.utils.aoa_to_sheet(data);
    const colWidths = headers.map((h, colIndex) => {
      const maxLength = Math.max(
        String(h).length,
        ...rows.map((r) => String(r[colIndex] ?? "").length)
      );
      return { wch: maxLength + 2 };
    });
    ws["!cols"] = colWidths;
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Data");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${formDataList?.[0]?.fieldRow?.FORM || "export"}.xlsx`);
  };


  const getTablePropertiesData = async (e) => {
    let data = await studyOtherSettingsServices.getTablePropertiesData(
      `dataListByFieldNameLabel${formId}`,
      studyId
    );
    setTableColumns(data?.data || []);
  };

  const updateTableProperties = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Update Table Property!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Update it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.studyId = studyId;
        userData.type = `dataListByFieldNameLabel${formId}`;
        userData.columns = tableColumns;
        let data = await studyOtherSettingsServices.updateTableProperties(
          userData
        );
        if (data?.statusCode === 200) {
          getTablePropertiesData();
        }
      }
      setButtonLoader(false);
    });
  };

  useEffect(() => {
    if (formId) {
      getAllDataEntryDatasetsByNameLabel();
    }
  }, [formId, pageNumber, itemsPerPage]);

  useEffect(() => {
    setPageNumber(1)
    setItemsPerPage(10)
    getTablePropertiesData();
  }, [formId]);

  useEffect(() => {
    getStudyLevelForm();
  }, []);
  return (
    <>
      <SplitPane split="vertical" minSize={"20%"} className="position-relative" style={{ height: "calc(100vh - 145px)" }}>
        {loading ? (
          <PageLoader/>
        ) : formMetadataList?.length === 0 ? (
          <div className="hstack justify-content-center h-100">
            <NoDataFoundTable MSG={"Data list not found!"} />
          </div>
        ) : (
          <ListGroup className="p-2">
            {formMetadataList?.map((form, index) => (
              <ListGroup.Item action
                title={form?.formLabel}
                onClick={() => {
                  setFormId(form?.formId);
                }}
                key={index}
                style={{ padding: "7px 0px 7px 10px" }}
                className={`hstack ${formId === form?.formId && "selectedMenu"}`}
              >
                <span>{form?.formName}</span>
              </ListGroup.Item>
            ))}
          </ListGroup>

        )}
        <>
          <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
            {formId &&
              <div className="hstack gap-1">
                <i onClick={setToggle1} title="Open Filter" className="fa-solid fa-filter"></i>
                <div className="vr"></div>
                <div className="sync">
                  <FaArrowsRotate
                    onClick={storeAllDataEntryDatasetsByNameLabel}
                    style={{ marginTop: -5, fontSize: 13 }}
                    title={dataStoreLoader ? "Syncing..." : "Sync now"}
                    className={dataStoreLoader ? "rotate360 fontSize12" : "CP fontSize12"}
                  />
                </div>
                {dataStoreLoader && <span className="fontSize12">Syncing...</span>}
              </div>
            }
            <div className="hstack gap-2">
              {formDataColumn?.length > 0 && (
                <div className="gap-1 hstack">
                  <button
                    className={`updateProfile`}
                    onClick={() => setToggle()}
                  >
                    Table Properties
                  </button>
                  {(studyPermission?.dbpAllAccess || studyPermission?.liveExtractDatasets || studyPermission?.qcExtractDatasets) ?
                    <>
                      <button
                        onClick={() => getAllDataEntryCSVDownloadDatasets(true)}
                        className={`updateProfile`}
                        disabled={csvLoader}
                      >
                        Download CSV
                      </button>
                      <button
                        disabled={excelLoader}
                        onClick={() => getAllDataEntryExcelDownloadDatasets(true)}
                        className={`updateProfile`}
                      >
                        Download Excel
                      </button>
                    </>
                    :
                    <>
                      <button
                        onClick={() => getAllDataEntryCSVDownloadDatasets(false)}
                        className={`updateProfile`}
                        disabled={csvLoader}
                      >
                        Download CSV
                      </button>
                      <button
                        disabled={excelLoader}
                        onClick={() => getAllDataEntryExcelDownloadDatasets(false)}
                        className={`updateProfile`}
                      >
                        Download Excel
                      </button>
                    </>
                  }
                </div>
              )}
            </div>
          </div>
          {dataLoader ? (
            <div className="hstack justify-content-center"
              style={{ height: "calc(100vh - 181px)" }}>
              <img src={Loader} alt="Page Loader" />
            </div>
          ) : !formId ? (
            <div className="hstack justify-content-center fw-bold text-muted"
              style={{ height: "calc(100vh - 181px)" }}>
              Not any field!
            </div>
          ) : formDataCount === 0 ? (
            <NoDataFoundTable MSG={"Data Not Found!"} />
          ) : (
            <>
              <div className="overflow-auto" style={{ height: "calc(100vh - 181px)" }}>
                <Table ref={tableRef} className="m-0 custom-table w-auto" hover striped>
                  <thead className="position-sticky top-0 z-1">
                    <tr>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 0)}
                        style={{ width: 45 }}
                        className="text-center"
                      >
                        Sr.
                      </th>
                      {(formDataColumn || []).map((key, idx) => (
                        tableColumns[key] ? "" :
                          <th onMouseDown={(e) => onMouseDown(e, idx + 1)} key={idx}>{key}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {(formDataList || []).map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        <td>
                          {rowIndex + 1 + startIndex}
                        </td>
                        {(formDataColumn || []).map((key, idx) => (
                          tableColumns[key] ? "" :
                            <td key={idx}>
                              {row?.fieldRow[key]}
                            </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="position-sticky bottom-0 start-0">
                  <Pagination
                    totalPage={totalPage}
                    pageNumber={pageNumber}
                    itemsPerPage={itemsPerPage}
                    totalItems={formDataCount}
                    setPageNumber={setPageNumber}
                    setItemsPerPage={setItemsPerPage}
                  />
                </div>
              </div>
            </>
          )}
        </>
      </SplitPane>
      <TableProperties
        Show={!toggle}
        Hide={setToggle}
        Title={"Table Properties"}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        formDataColumn={formDataColumn}
        tableColumns={tableColumns}
        buttonLoader={buttonLoader}
        setTableColumns={setTableColumns}
        updateTableProperties={updateTableProperties}
      />
      <DatasetFilter
        Show={!toggle1}
        Hide={setToggle1}
        Title={"Dataset Filter"}
        buttonFiletrLoader={buttonFiletrLoader}
      />
    </>
  );
};

export default DatasetListByFieldNameLabel;